import api from '../../api'
const state = {
    all:[]
}

const getters= {
    rows(state){
        let data = []
        let row = {
            id:'',
            entite_nom: "",
            typeoperations_libelle: "",
            typeoperation_code: "",
            valeur: "",
            date_du: "",
            date_au: "",
            created_at: null,
            updated_at: null,
            deleted_at: null,
            btn:""
        }
        state.all.forEach(element => {  
            console.log("mon element commission ",element)       
            row = {             
                id:element.id,
                entite_nom: element.entite_nom,
                typeoperations_libelle: element.typeoperations_libelle.toUpperCase(),
                typeoperation_code: element.typeoperation_code.toUpperCase(),
                valeur: element.valeur,
                date_du: element.date_du,
                date_au: element.date_au,
                created_at: element.created_at,
                deleted_at: element.deleted_at,
                updated_at: element.updated_at
            }
            data.push(row)
        });
        return data;
    }
}
const mutations= {
    setCommissions(state, commissions) {
        state.all = commissions
    },
    addCommission(state, commission) {
        state.all.push(commission)
    }
}

const actions={
    get_all_commissions({ commit }, serverParams){
        return api.commission.get_all_commissions(serverParams).then((response)=>{
            console.log("mes commissions ", response.data.data.data)
            commit('setCommissions', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    get_all_commissionsByEntite({ commit }, serverParams){
        return api.commission.get_all_commissionsByEntite(serverParams).then((response)=>{
            console.log("mes commissions ", response.data.data.data)
            commit('setCommissions', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    get_all_commissionsByTypeOperation({ commit }, serverParams){
        return api.commission.get_all_commissionsByTypeOperation(serverParams).then((response)=>{
            console.log("mes commissions ", response.data.data.data)
            commit('setCommissions', response.data.data.data)
            return response.data.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    post_commissions({commit},commission){
        return api.commission.post_commissions(commission).then((response)=>{
            commit('addCommission', response.data.data)
            return response.data
        })
        .catch(error=>{
            return error.response.data
        })
    },
    put_commissions({ commit }, data) {
        console.log("data ",data)
        return api.commission.put_commissions(data.id, data.commission).then((response) => {
            return response.data
        })
            .catch(error => {
                return error.response.data
            })
    },
    show_commissions({ commit }, id) {
        return api.commission.show_commissions(id).then((response) => {
            return response.data.data;
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
